module.exports = __webpack_public_path__ + "img/Left_three.e4017905.svg";